<button mat-icon-button 
  matTooltip="View Message Debug Call" color="accent" (click)="viewMessage()">
  <mat-icon>rate_review</mat-icon>
</button>
